var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"success_box"},[_c('img',{attrs:{"src":require("../../assets/ic_success.png")}}),_c('span',[_vm._v("支付成功")])])])
}]

export { render, staticRenderFns }